import { useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '@/lib/api'
import { USE_MOCKS } from '@/mocks/fixtures'

/* Sign-out (epics Story 1.2).
 *
 * The request is what actually ends the session: signing out invalidates it
 * SERVER-SIDE, so the cookie alone cannot restore it. Deleting the cookie from
 * the client would not be a sign-out — the token would stay valid for anyone
 * holding it, which is the whole point of an opaque server-side session
 * (AD-21).
 *
 * The cache is cleared in `onSettled` rather than `onSuccess`, deliberately. If
 * the request fails — offline, server down — the safe reading of "sign me out"
 * on a possibly shared machine is still to drop every cached record from the
 * screen. The server-side session may outlive that, and it will expire on its
 * own idle and absolute timers; leaving a signed-out user's cases on screen is
 * the worse of the two failures. */

export function useSignOut() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: () =>
      USE_MOCKS ? Promise.resolve() : api.delete<void>('/session'),

    onSettled: () => {
      queryClient.clear()
    },
  })
}
